// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactSection_container__yU-Qw","half":"ContactSection_half__19wuW"};